import customAxios from "./axiosConfig";

const QuotationService = {
  retrieve: function (quotation_id, params) {
    const api_url = '/api/v2/quotations/' + quotation_id + '/'
    return customAxios.get(api_url, { params: params });
  },
  list (params) {
    const api_url = window.Urls['quotation-list']()
    return customAxios.get(api_url, { params: params })
  },
  totalAmounts (params) {
    const api_url = window.Urls['quotation_totals']()
    return customAxios.get(api_url, { params: params })
  },
  changeStatus(pk, data) {
    const api_url = window.Urls['quotation_change_status'](pk);
    return customAxios.put(api_url, data);
  },
  destroy(pk) {
    const api_url = window.Urls['quotation_detail'](pk);
    return customAxios.delete(api_url);
  },
  customerList (params) {
    const api_url = window.Urls['quotation_customer_list']();
    return customAxios.get(api_url, {params: params});
  }
}

export default QuotationService;
